<template>
  <section id="bike-theft-claim-flow" data-test="bike-theft-claim-flow">
    <!-- page-spinner -->
    <page-spinner :spinner-url-list="spinnerUrlList" />

    <!-- header -->
    <static-header v-if="!loading" @close="leaveFlow" />

    <!-- flow -->
    <div class="flow__body container" v-if="routerReady">
      <VeeForm v-slot="{ errors, handleSubmit }" as="div" ref="form">
        <form @submit="handleSubmit($event, submitClaim)">
          <!-- <transition name="fade" mode="out-in" @after-enter="scrollToTop">
          <router-view />
        </transition> -->

          <router-view v-slot="{ Component }">
            <transition name="fade" mode="out-in" @after-enter="scrollToTop">
              <component :is="Component" :errors="errors" />
            </transition>
          </router-view>
        </form>
      </VeeForm>
    </div>

    <!-- modal -->
    <v-modal :is-open="showModal" @close="$store.dispatch('bikeTheftClaimFlow/closeModal')">
      <template #title>
        {{ modalData.title }}
      </template>
      <template #content>
        {{ modalData.text }}
      </template>
      <template #buttons>
        <modal-buttons :buttons="modalData.buttons" :loading="false" />
      </template>
    </v-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import StaticHeader from '@/components/UI/StaticHeader.vue';
import ModalButtons from '@/components/UI/ModalButtons.vue';
import PageSpinner from '@/components/UI/PageSpinner.vue';
import Utility from '@/common/UtilityFunctions.js';
import { Form as VeeForm } from 'vee-validate';

export default {
  name: 'BikeTheftClaimFlow',
  // router,
  components: {
    ModalButtons,
    PageSpinner,
    StaticHeader,
    VeeForm
  },
  data() {
    return {
      routerReady: false
    };
  },
  computed: {
    ...mapState({
      claimSubmitted: (state) => state.bikeTheftClaimFlow.claimSubmitted,
      files: (state) => state.bikeTheftClaimFlow.data.uploadData.files,
      filesUploaded: (state) => state.bikeTheftClaimFlow.filesUploaded,
      loading: (state) => state.bikeTheftClaimFlow.loading,
      modalData: (state) => state.bikeTheftClaimFlow.modalData,
      showModal: (state) => state.bikeTheftClaimFlow.showModal
    }),
    spinnerUrlList() {
      return [
        Utility.constants().API.bike_theft_claim_flow_initiate +
          '/' +
          Utility.getQueryVariableFromRouterUrl('id')
      ];
    },
    pushConformationRoute() {
      if (this.claimSubmitted && this.files.length > 0 && this.filesUploaded) {
        return true;
      }

      if (this.claimSubmitted && this.files.length > 0 && !this.filesUploaded) {
        return false;
      }

      return this.claimSubmitted;
    }
  },
  mounted() {
    this.$router.isReady().then(() => {
      this.$store.dispatch('bikeTheftClaimFlow/getInitialData', this.$route.params.id);
      this.routerReady = true;
    });
  },
  methods: {
    async submitClaim() {
      const result = await this.$refs.form.validate();

      if (!result?.valid) {
        return;
      }

      await this.$store.dispatch('bikeTheftClaimFlow/submitClaim');

      if (this.claimSubmitted && this.files.length > 0) {
        await this.$store.dispatch('bikeTheftClaimFlow/uploadFiles');
      }

      if (this.pushConformationRoute) {
        this.$router.push('/opret-cykel-skade/what/bike/summary/confirmation');
      }
    },
    leaveFlow() {
      location.href = '/';
    },
    scrollToTop() {
      Utility.scrollToTop();
    }
  }
};
</script>
